import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

const client = createClient('/rest/operator-api/charging-stations');

export interface SetCredentialsRequest {
  password: string;
  protocol?: string;
}

export const setCredentials: SaveOperation<SetCredentialsRequest, void, string> = postRequestFactory<
  SetCredentialsRequest,
  void,
  string
>(client, {
  pattern: '/{chargingStationId}/set-credentials',
  permissionId: commandPermissions.SET_CREDENTIALS
});
